<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="coefficientScheme"
      :items="coefficientScheme"
      :fields="coefficientSchemeFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
     <editModal :editItem="selectedCoefficientScheme"/>
  </div>
</template>

<script>
import editModal from './editModal'
export default {
  components: {
    editModal
  },
  data () {
    return {
      coefficientSchemeFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true},
        {key: 'create_date', label: this.$i18n.t('Creation date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'change_date', label: this.$i18n.t('Modification date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedCoefficientScheme: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedCoefficientScheme = {
        id: 0,
        name: '',
        comment: '',
        items: []
      }
      this.$root.$emit('bv::show::modal', 'modalEditCoefficientScheme', '#btnShow')
    },
    editItem (item) {
      this.selectedCoefficientScheme = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditCoefficientScheme', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Coefficient scheme"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Tariffing/DELETE_COEFFICIENT_SCHEME', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_COEFFICIENT_SCHEME')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    coefficientScheme () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/COEFFICIENT_SCHEME']))
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_COEFFICIENT_SCHEME')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/additional/coefficientScheme/main.vue